const baseURL = process.env.baseURL || process.env.VUE_APP_API_URL || ""
const sysType = "SCM" // SCM or PCCV
const mqttWSURL = "ws://192.168.1.8:1884"
export default {
    baseURL,
    sysType,
    mqttWSURL
}